import BaseStore from 'stores/BaseStore';
import { deepMerge } from 'toolbox/deepMerge';

const initialData = {};

/**
 * Returns state update after product update
 * @param {Object} state store state
 * @returns {Object} state to update
 */
function stateAfterProductsUpdate(state) {
    return {
        limitExceeded: state.products.length === state.productsLimit,
    };
}

/**
 * Returns comparison instance state
 * @param {Object} state store state
 * @param {String} instanceId comparison instance id
 * @returns {Object} state to update
 */
function getInstance(state, instanceId) {
    return state[instanceId || 'default'];
}

/**
 * Returns state update for instance
 * @param {Object} state store state
 * @param {String} instanceId comparison instance id
 * @returns {Object} state to update
 */
function saveInstance(state, instanceId) {
    return {
        [instanceId || 'default']: state,
    };
}

const comparisonStore = new BaseStore(initialData, {
    init: (state, data) => {
        const instanceId = data && data.instanceId;
        if (getInstance(state, instanceId)) {
            return state;
        }
        return deepMerge(state, saveInstance(Object.assign({
            showComparisonButtons: false,
            products: [],
            productsLimit: 6,
            limitExceeded: false,
        }, data), instanceId));
    },
    enable: (state, data) => deepMerge(
        state,
        saveInstance({
            showComparisonButtons: true,
        }, data && data.instanceId),
    ),
    addProduct: (state, data) => {
        const instance = getInstance(state, data.instanceId);
        if (instance.products.length < instance.productsLimit) {
            instance.products.push({ pid: data.pid, masterId: data.masterId });
        }
        return deepMerge(state, saveInstance(stateAfterProductsUpdate(instance), data.instanceId));
    },
    removeProduct: (state, data) => {
        const instance = getInstance(state, data.instanceId);
        const pid = data.masterId || data.pid;
        instance.products = instance.products.filter(product => product.pid !== pid && product.masterId !== pid);
        return deepMerge(state, saveInstance(stateAfterProductsUpdate(instance), data.instanceId));
    },
    replaceProduct: (state, data) => {
        if (data.previousPid === data.pid) {
            return state;
        }
        const instance = getInstance(state, data.instanceId);
        instance.products = instance.products
            // remove already existing variations with pid
            .filter(product => product.pid !== data.pid)
            // replace variation with new one
            .map((product) => {
                if (product.pid === data.previousPid) {
                    product.pid = data.pid;
                }

                return product;
            });

        return deepMerge(state, saveInstance(stateAfterProductsUpdate(instance), data.instanceId));
    },
    reset: (state, data) => {
        const instanceId = data && data.instanceId;
        return deepMerge(state, saveInstance({
            showComparisonButtons: false,
            products: [],
            limitExceeded: false,
        }, instanceId));
    },
});

export default comparisonStore;
